import React from 'react';
import styled from 'styled-components';

import LockIcon from './lock-icon.svg';

const SecureTransaction = () => {
	return (
		<SecureTransactionContainer>
			<Icon src={LockIcon} />
			<NormalText>Secure Transaction</NormalText>
		</SecureTransactionContainer>
	);
};

const SecureTransactionContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	margin-top: 30px;
	margin-bottom: 20px;
`;

const Icon = styled.img`
	width: 10px;
	margin-right: 5px;
`;

const NormalText = styled.p`
	color: ${({ theme }) => theme.colors.darkR};
	margin: 0;
`;

export default SecureTransaction;
